import { useState } from "react";
import { FaHandshake, FaUsers, FaHeadset } from "react-icons/fa";
import { motion } from "framer-motion";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const features = [
    {
      icon: <FaHandshake className="text-2xl md:text-3xl text-yellow-500" />,
      title: "Trusted by Thousands",
      description: "Growing community of buyers, sellers & partners.",
    },
    {
      icon: <FaUsers className="text-2xl md:text-3xl text-green-500" />,
      title: "For Everyone",
      description:
        "Buyers, sellers, agents, and builders—one trusted platform.",
    },
    {
      icon: <FaHeadset className="text-2xl md:text-3xl text-blue-500" />,
      title: "End-to-End Support",
      description: "From search to possession, we're with you.",
    },
  ];

  const featureVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5, ease: "easeOut" },
    }),
  };

  return (
    <div className="w-full mx-auto">
      <div className="bg-white rounded-xl border shadow-sm p-4 w-full">
        {/* Header */}
        <h2 className="font-semibold text-primary-navy text-lg lg:text-base  tracking-[0.01em] leading-[150%] text-center  mb-2 md:mb-4 lg:mb-6 pt-2 md:pt-4">
          Contact our Real Estate Experts
        </h2>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="space-y-3 sm:space-y-4 mb-6 md:mb-8 border-t border-b py-4 sm:py-6 w-full"
        >
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
            className="w-full px-3 sm:px-4 py-2.5  bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-transparent placeholder-gray-400 text-sm"
          />
          <input
            type="email"
            name="email"
            placeholder="Email ID"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full px-3 sm:px-4 py-2.5  bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-transparent placeholder-gray-400 text-sm "
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleInputChange}
            className="w-full px-3 sm:px-4 py-2.5  bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-transparent placeholder-gray-400 text-sm "
          />
          <button
            type="submit"
            className="w-full py-3  bg-red-500 text-white font-semibold rounded-xl sm:rounded-2xl hover:bg-red-600 transition-all duration-300 text-lg lg:text-base active:scale-[0.97]"
          >
            Contact Now
          </button>
        </form>

        {/* Features Section */}
        <div className="mb-4 w-full">
          <h3 className="font-medium text-primary-navy tracking-[0.01em] text-lg lg:text-base mb-2 md:mb-4 lg:mb-6">
            From Search to Sale—LeadBook Makes It Easy.
          </h3>

          <div className="space-y-4 sm:space-y-6">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="flex items-start gap-3 sm:gap-4"
                custom={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={featureVariants}
              >
                <div className="flex-shrink-0 mt-1">{feature.icon}</div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm ">
                    {feature.title}
                  </h4>
                  <p className="text-xs text-text-secondary leading-relaxed text-justify">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
